import type { components } from "@/api/schema";

type GlobalAuditEvent = components["schemas"]["GlobalAuditEvent"];

/**
 * Maps an audit target to a real internal href. The API resolves order targets
 * to the marketplace sale_order_id first.
 */
export function targetToHref(
  event: Pick<GlobalAuditEvent, "target_type" | "target_id"> &
    Partial<Pick<GlobalAuditEvent, "activity">>,
): string | null {
  const id = event.target_id;
  if (!id) return null;
  const encoded = encodeURIComponent(id);

  switch (event.target_type) {
    case "sku":
      if (event.activity?.startsWith("inventory.ratio_policy_")) {
        return `/inventory-ratio?sku=${encoded}`;
      }
      return `/inventory?search=${encoded}&offset=0`;
    case "campaign":
      return `/promotion?campaign_id=${encoded}`;
    case "promotion":
      return `/promotion/${encoded}`;
    case "order":
      return `/orders/${encoded}`;
    // `sino_order_ref` deliberately stays unlinked: the id is a warehouse-side
    // reference with no Atlas route. New warehouse events target the order
    // itself ("order"), so this only affects history.
    default:
      return null;
  }
}
